import { OrderComponent } from "./components/order/order.component";
import { OrderItemComponent } from "./components/order-item/order-item.component";

window.customElements.define(OrderComponent.tagName(), OrderComponent);
window.customElements.define(OrderItemComponent.tagName(), OrderItemComponent);
